<template>
	<view class="activity-item">
		<view class="activity-message">
			<image src="../../static/uni.png" mode=""></image>
			<view class="message-container">
				<view class="merchant-title">白雪公主</view>
				<view class="activity-option">
					<text class="activity-option-label">报名信息：</text>
					<text class="activity-option-value">李德博｜18199883949</text>
				</view>
				<view class="activity-option">
					<text class="activity-option-label">企业名称：：</text>
					<text class="activity-option-value">-</text>
				</view>
				<view class="activity-option">
					<text class="activity-option-label">报名时间：</text>
					<text class="activity-option-value">2023-03-12 19:00</text>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		name:"activityApplyItem",
		props: {
			itme: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
.activity-item {
	background-color: #fff;
	padding: 28rpx 32rpx;
	border-bottom: 10px solid #f7f7f7;
	// height: 200rpx;
	.activity-message {
		display: flex;
		image {
			width: 72rpx;
			height: 72rpx;
			border-radius: 50%;
			margin-right: 20rpx;
		}
		.message-container {
			flex: 1;
			.merchant-title {
				height: 30rpx;
				font-size: 30rpx;
				font-weight: 600;
				color: #222222;
				line-height: 30rpx;
			}
			.activity-option {
				font-size: 24rpx;
				font-weight: 400;
				color: #666666;
				line-height: 24rpx;
				margin-top: 20rpx;
				.activity-option-label {
					color: #666666;
				}
				.activity-option-value {
					color: #333333;
				}
				
			}
			
		}
		.activity-status {
			ont-size: 26rpx;
			font-weight: 400;
			color: #D20A0A;
			line-height: 26rpx;
		}
	}
	.bottom-line {
		margin-top: 26rpx;
		display: flex;
		justify-content: space-between;
		height: 52rpx;
		font-size: 24rpx;
		font-weight: 400;
		color: #999999;
		line-height: 52rpx;
		.bottom-actions {
			width: 304rpx;
			display: flex;
			justify-content: space-between;
			.action {
				width: 144rpx;
				height: 52rpx;
				border-radius: 28rpx;
				border: 2rpx solid #D9D9D9;
				box-sizing: border-box;
				font-size: 26rpx;
				font-weight: 400;
				color: #333333;
				text-align: center;
			}
			.del-actions {
				border: 2rpx solid #D20A0A;
				color: #D20A0A;
			}
		}
	}
}
</style>